import React from 'react';
const defaultContextValue = {
  ref: null
};
const AppContext = /*#__PURE__*/React.createContext(defaultContextValue);
export { AppContext };
//# sourceMappingURL=AppContext.js.map